/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
const formValidation = require('base/components/formValidation');
const createErrorNotification = require('base/components/errorNotification');


/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart-quantity').trigger('count:update', response);
    const messageType = response.error ? 'alert-danger' : 'alert-success';
    let messageIcon;

    if (!response.error) {
        messageIcon = '<span class="icon-checked-line"></span>';
    } else {
        messageIcon = '<span class="icon-alert"></span>';
    }

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
            '<div class="add-to-cart-messages"></div>',
        );
    }

    $('.add-to-cart-messages').append(
        `<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">${messageIcon} ${response.message}</div>`,
    );

    setTimeout(() => {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * Used to initiate ajax call and update the form
 * @param {Object} form - gift certificate form
 * @param {boolean} isUpdate - boolean value to check if it is update action
 * @return {boolean} false
 */
const updateGiftCertForm = function (form, isUpdate) {
    const url = form.attr('action');
    form.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        // eslint-disable-next-line consistent-return
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
            } else {
                if (!isUpdate) {
                    handlePostCartAdd(data);
                    const token = $('#token').val();
                    form.find('input,textarea').val('');
                    $('#token').val(token);
                    return false;
                }
                window.location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else if (isUpdate) {
                $('.error-gift-certificate').html('');
                createErrorNotification($('.error-gift-certificate'), err.responseJSON.errorMessage);
                $('.html, body').animate({
                    scrollTop: $('.error-gift-certificate').offset().top,
                }, 1000);
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }
            form.spinner().stop();
        },
    });
    return false;
};

/**
 * Used to initiate ajax call and check gift card balance
 * @param {Object} form - check balance form
 */
const checkBalance = function (form) {
    const url = form.attr('action');
    form.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
            } else {
                $('#gift-balance-msg').html(data.giftCertificate.balance).removeClass('red');
            }
        },
        error: function (err) {
            form.spinner().stop();
            $('#gift-balance-msg').html(err.responseJSON.error).addClass('red');
        },
    });
};

function displayMessage(data, button) {
    $.spinner().stop();
    // eslint-disable-next-line no-unused-vars
    let status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }
    button.removeClass('moveToWishlist');
}

module.exports = {
    addToBasket: function () {
        $('form.giftcert').submit(function (e) {
            const form = $(this);
            e.preventDefault();
            updateGiftCertForm(form, false);
        });
    },
    updateGiftCertificate: function () {
        $('body').on('click', '.update-gift-certificate', (e) => {
            const form = $(e.currentTarget).parents('.giftcert');
            e.preventDefault();
            updateGiftCertForm(form, true);
        });
    },
    checkGiftCertBalance: function () {
        $('body').on('click', '#CheckBalanceButton', (e) => {
            const form = $('.check-balance');
            e.preventDefault();
            checkBalance(form);
        });
    },
    moveToWishlist: function () {
        $('body').on('click', '.moveToWishlist', function (e) {
            e.preventDefault();
            const url = $(this).data('href');
            const pid = $(this).data('pid');
            const button = $(this);
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                },
                success: function (data) {
                    $('.moveToWishlist').text('Wishlist Added');
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                },
            });
        });
    },
};
